export function reconcileViewport(doc = typeof document !== 'undefined' ? document : undefined, win = typeof window !== 'undefined' ? window : undefined) {
  const height = win?.visualViewport?.height || win?.innerHeight || 0;
  if (height > 0) doc?.documentElement?.style?.setProperty('--app-viewport-height', `${Math.round(height)}px`);
  return height;
}

export function subscribeViewport(listener = () => {}, { doc = typeof document !== 'undefined' ? document : undefined, win = typeof window !== 'undefined' ? window : undefined } = {}) {
  const update = () => listener(reconcileViewport(doc, win));
  update();
  win?.addEventListener?.('resize', update);
  win?.visualViewport?.addEventListener?.('resize', update);
  return () => {
    win?.removeEventListener?.('resize', update);
    win?.visualViewport?.removeEventListener?.('resize', update);
  };
}
